import util from '@bmp-vue/core/api/util'
const controller = 'Afagu'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.DtoConsultaMotor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_CONSULTAMOTOR', ValorCampo: JSON.stringify(th.model.DtoConsultaMotor) }) }

    return th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos })
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
})

export default ctrl
